<div class="h-full overflow-hidden p-6 box-border">
  <div>
    @switch (viewType()) {
      @case (ROLLUP_VIEW_TYPES.BUDGET_LINE_ITEMS) {
        <div class="text-navy-600 font-semibold text-sm">Budget Line Breakdown</div>
      }
      @case (ROLLUP_VIEW_TYPES.TAGS) {
        <div class="text-navy-600 font-semibold text-sm">Budget Tag Breakdown</div>
      }
    }
  </div>
  <div class="flex flex-col h-full w-full overflow-hidden">
    <ng-scrollbar appearance="compact" orientation="vertical" class="std-scrollbar">
      <div class="row header">
        <div class="ml-2 col-span-3"></div>
        <div class="uppercase item text-navy-500 font-bold text-size_xs">Committed</div>
        <div class="uppercase item text-navy-500 font-bold text-size_xs">Actuals</div>
        <div class="uppercase item text-navy-500 font-bold text-size_xs">Act vs com</div>
      </div>
      @switch (viewType()) {
        @case (ROLLUP_VIEW_TYPES.BUDGET_LINE_ITEMS) {
          <div class="row">
            <span class="col-span-3 text-navy-900 font-bold text-base">
              {{ bliData()?.name ?? 'Default Budget Line' }}
            </span>
            <span class="item text-navy-900 font-bold text-sm">
              <app-formatted-money [value]="bliData()?.total_committed"></app-formatted-money
            ></span>
            <span class="item text-navy-900 font-bold text-sm">
              <app-formatted-money [value]="bliData()?.actuals"></app-formatted-money
            ></span>
            <span class="item text-navy-900 font-bold text-sm">
              <app-formatted-money [value]="bliData()?.total_committed - bliData()?.actuals"></app-formatted-money>
            </span>
          </div>

          <div class="border-bottom"></div>

          @for (project of bliData()?.projects; track project; let last = $last) {
            <div class="ml-2 row">
              <span class="ml-2 col-span-3 text-navy-900 font-semibold text-sm">{{ project?.title }}</span>
              <span class="item font-semibold text-sm">
                <app-formatted-money [value]="project?.cash_flow?.total_committed"></app-formatted-money>
              </span>
              <span class="item font-semibold text-sm">
                <app-formatted-money [value]="project?.cash_flow?.actuals"></app-formatted-money>
              </span>
              <span class="item font-semibold text-sm">
                <app-formatted-money
                  [value]="project?.cash_flow?.total_committed - project?.cash_flow?.actuals"
                ></app-formatted-money>
              </span>
            </div>
            @if (!last) {
              <div class="border-bottom"></div>
            }
          }
        }

        @case (ROLLUP_VIEW_TYPES.TAGS) {
          <div class="row">
            <span class="col-span-3 text-navy-900 font-bold text-base">
              {{ tagsData()?.name ?? 'Default Tag' }}
            </span>
            <span class="item text-navy-900 font-bold text-sm">
              <app-formatted-money [value]="tagsData()?.total_committed"></app-formatted-money
            ></span>
            <span class="item text-navy-900 font-bold text-sm">
              <app-formatted-money [value]="tagsData()?.actuals"></app-formatted-money
            ></span>
            <span class="item text-navy-900 font-bold text-sm">
              <app-formatted-money [value]="tagsData()?.total_committed - tagsData()?.actuals"></app-formatted-money>
            </span>
          </div>

          <div class="border-bottom"></div>

          @for (item of tagsData()?.items; track item; let last = $last) {
            <div class="ml-2 row">
              <span class="ml-2 col-span-3 text-navy-900 font-semibold text-sm">{{ item?.name }}</span>
              <span class="item font-semibold text-sm">
                <app-formatted-money [value]="item?.cash_flow?.total_committed"></app-formatted-money>
              </span>
              <span class="item font-semibold text-sm">
                <app-formatted-money [value]="item?.cash_flow?.actuals"></app-formatted-money>
              </span>
              <span class="item font-semibold text-sm">
                <app-formatted-money
                  [value]="item?.cash_flow?.total_committed - item?.cash_flow?.actuals"
                ></app-formatted-money>
              </span>
            </div>
            @if (!last) {
              <div class="border-bottom"></div>
            }
          }
        }
      }
    </ng-scrollbar>
  </div>
</div>
